<template>
  <section class="py-10 pb-12 lg:py-12 lg:pb-[4.5rem]">
    <div class="container mx-auto max-w-[1200px] px-4">
      <h2 class="landing_h2 mb-8 lg:mb-10 text-center">
        <Translate translate-key="how_it_works.title" />
      </h2>
      <ul class="list-none p-0 m-0 space-y-10 lg:space-y-10">
        <li
          v-for="(item, index) in boostList"
          :key="item.id"
          class="grid items-center gap-6 lg:grid-cols-2 lg:gap-12"
        >
          <div
            class="innerContent text-left"
            :class="index === 1 ? 'lg:order-1' : 'lg:order-2'"
          >
            <div
              class="prose prose-gray max-w-none text-gray-700 prose-p:mb-3 prose-ul:my-3 prose-li:my-0.5 prose-a:text-success prose-a:underline hover:prose-a:no-underline prose-strong:font-semibold"
              v-html="item.textContent"
            />
          </div>
          <div :class="index === 1 ? 'lg:order-2' : 'lg:order-1'">
            <NuxtImg
              :src="item.img"
              :alt="item.alt"
              width="430"
              height="330"
              format="webp"
              class="w-full max-w-[430px] rounded-lg object-cover mx-auto lg:mx-0"
              loading="lazy"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const boostList = computed(() => [
  {
    id: "bl-1",
    img: "/boost/turn-credit-history-into-money.png",
    textContent: t("how_it_works.boostList.1.text"),
    alt: t("how_it_works.boostList.1.alt"),
  },
  {
    id: "bl-2",
    img: "/boost/save-money-on-interest.png",
    textContent: t("how_it_works.boostList.2.text"),
    alt: t("how_it_works.boostList.2.alt"),
  },
  {
    id: "bl-3",
    img: "/boost/benefit-from-credit-cards.png",
    textContent: t("how_it_works.boostList.3.text"),
    alt: t("how_it_works.boostList.3.alt"),
  },
]);
</script>

<style scoped>
.innerContent :deep(a) {
  @apply text-teal-600 underline;
}
.innerContent :deep(ul) {
  @apply list-disc pl-5;
}
.innerContent :deep(strong) {
  @apply font-semibold;
}
</style>
